import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { useSportsRealtimeResults } from 'projectSpecific/sports/useHelpers/useSportRealtimeResults'
import { useSportResults } from 'projectSpecific/sports/useHelpers/useSportResults'
import { _sportsInfoTypes, useSportsInfo } from 'projectSpecific/sports/useHelpers/useSportsInfo'
import { createContext, useContext, useEffect, useState } from 'react'
import { SportsDistrictContext } from './SportsDistrictContext'
import { SportsSeasonContext } from './SportsSeasonContext'

export const SportsSeasonDataContext = createContext();

export const SportsSeasonDataProvider = (props) => {

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state } = states ?? {}

  const { pathViews } = paps_state ?? {}

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data } = sportsDistrict_state ?? {}
  const { sports } = district_data ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_handlers } = sportsSeasonContext ?? {}

  const sportsMode = {
    organizations: pathViews && pathViews.organizations && !pathViews.districts && !pathViews.schools && !pathViews.matches && !pathViews.sports && !pathViews.teams ? true : false,
    districts: pathViews && pathViews.districts && !pathViews.schools && !pathViews.matches && !pathViews.sports && !pathViews.teams ? true : false,
    matches: pathViews && pathViews.matches ? true : false,
    schools: pathViews && pathViews.schools ? true : false,
    sports: pathViews && pathViews.sports && !pathViews.teams ? true : false,
    teams: pathViews && pathViews.teams ? true : false,
    sportLanding: pathViews && pathViews.sports && !pathViews.teams && !pathViews.matches
  }

  const sportsInfo = useSportsInfo({ sportsInfoType: _sportsInfoTypes.sportsSeason, sports, sportsMode })
  const sportsResultsInfo = useSportResults({ sportsInfoType: _sportsInfoTypes.sportsSeason, sports })
  const sportsRealtimeResultsInfo = useSportsRealtimeResults({ sportsInfoType: _sportsInfoTypes.sportsSeason, sports })

  const [sportsSeasonData, setSportsSeasonData] = useState({})

  // console.log('sportsSeasonData', sportsSeasonData)

  useEffect(() => {
    const _sportsSeasonData = _.cloneDeep(sportsSeasonData)
    setSportsSeasonData({ ..._sportsSeasonData, ...sportsInfo })
    sportsSeason_handlers.handleSet_sportsInfo(sportsInfo)
  }, [sportsInfo]);

  useEffect(() => {
    const _sportsSeasonData = _.cloneDeep(sportsSeasonData)
    setSportsSeasonData({ ..._sportsSeasonData, ...sportsResultsInfo })
    sportsSeason_handlers.handleSet_sportsResultsInfo(sportsResultsInfo)
  }, [sportsResultsInfo]);

  useEffect(() => {
    sportsSeason_handlers.handleSet_sportsRealtimeResultsInfo(sportsRealtimeResultsInfo)
  }, [sportsRealtimeResultsInfo]);

  return <SportsSeasonDataContext.Provider value={{ sportsSeasonData_state: { sportsSeasonData } }}>
    {props.children}
  </SportsSeasonDataContext.Provider>


}
